import React, { useRef, useState } from "react";
import cpyIcon from "../../assets/UserIcons/Copy.svg";
import tickIcon from "../../assets/icons/icons_tick.png";

export default function TableWithCopy({ children }) {
  const tableRef = useRef(null);
  const [copied, setCopied] = useState(false);

  const copyTable = () => {
    if (!tableRef.current) return;

    const rows = Array.from(tableRef.current.querySelectorAll("tr"))
      .map((row) =>
        Array.from(row.querySelectorAll("th, td"))
          .map((cell) => cell.innerText.trim())
          .join("\t")
      )
      .join("\n");

    navigator.clipboard.writeText(rows);
    setCopied(true);

    // Reset copied icon after 1.5 sec
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <div className="position-relative pt-4">
      <button
        onClick={copyTable}
        className="copy-table-btn"
        style={{
          position: "absolute",
          top: "2px",
          right: "5px",
          padding: "5px 10px",
          fontSize: "9px",
          cursor: "pointer",
          borderRadius: "6px",
          color: "white",
          background: "rgba(255,255,255,0.08)",
          border: "1px solid rgba(0, 0, 0, 0.41)",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          backdropFilter: "blur(4px)",
          zIndex: 9999,
        }}
      >
        <img
          src={copied ? tickIcon : cpyIcon}
          className="icon-image"
          alt={copied ? "Copied" : "Copy"}
          style={{ width: "16px", height: "16px" }}
        />
        <span className="refresh-prompts" style={{ fontSize: "12px" }}>
          {copied ? "Copied" : "Copy Table"}
        </span>
      </button>
      <div
        className="table-wrapper border-0  overflow-x-scroll"
        style={{ position: "relative" }}
      >
        <table
          ref={tableRef}
          className="markdown-table table table-bordered  "
          style={{
            width: "100%",
            marginTop: "10px",
            borderCollapse: "collapse",
          }}
        >
          {children}
        </table>
      </div>
    </div>
  );
}
